import { Components, Theme } from '@mui/material/styles';

export const flowFormControlLabel: Components<Theme>['MuiFormControlLabel'] = {
  styleOverrides: {
    root: {
      marginLeft: '0',
      // in case the text should be recolored as well
      // '&:has(.MuiCheckbox-colorError), &:has(.MuiSwitch-colorError), &:has(.MuiRadio-colorError)': {
      //   '& .MuiFormControlLabel-label:not(.Mui-disabled)': {
      //     color: theme.palette.error.main,
      //   },
      // },
    },
    label: ({ theme }) => ({
      paddingTop: '4px',
      paddingBottom: '4px',
      letterSpacing: '0.2px',
      fontSize: '14px',
      lineHeight: '24px',
      fontWeight: '400',
      color: theme.palette.text.primary,
      // space between Label and element (e.g. checkbox)
      paddingLeft: '8px',
      // disabled style
      '&.Mui-disabled': {
        color: theme.palette.disabled.tertiary,
      },
    }),
    labelPlacementStart: {
      marginLeft: '16px',
      marginRight: '0',
      '& .MuiFormControlLabel-label': {
        paddingLeft: '0',
        paddingRight: '8px',
      },
    },
  },
};
